import { includes } from 'lodash';
import { PHONE_TYPES_THAT_CAN_RECEIVE_WRITTEN_COMMUNICATION } from '../constants';

export default function phoneCanReceiveWrittenCommunication(phoneType = '') {
  const phoneTypeEmpty = phoneType === '';
  return phoneTypeEmpty || includes(PHONE_TYPES_THAT_CAN_RECEIVE_WRITTEN_COMMUNICATION, phoneType);
}
